import { render, staticRenderFns } from "./NotePanel.vue?vue&type=template&id=5de47aec&"
import script from "./NotePanel.vue?vue&type=script&lang=js&"
export * from "./NotePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports